import React from "react";
import PropTypes from "prop-types";

import Checkbox from "./Checkbox";

function BooleanInput({
  name,
  label,
  size,
  value,
  onChange,
  readOnly,
  disabled,
  ...props
}) {
  return (
    <Checkbox
      {...props}
      checked={!!value}
      className="checkbox"
      disabled={disabled}
      id={name}
      label={label}
      name={name}
      readOnly={readOnly}
      size={size}
      onChange={onChange}
    />
  );
}
BooleanInput.propTypes = {
  name: PropTypes.string,
  size: PropTypes.string,
  label: PropTypes.string,
  value: PropTypes.bool,
  onChange: PropTypes.func,
  readOnly: PropTypes.bool,
  disabled: PropTypes.bool
};

export default BooleanInput;
